import { generateActions } from "../utils";

export const SIGN_UP = generateActions("SIGN_UP");
export const SIGN_IN = generateActions("SIGN_IN");
export const VERIFY_EMAIL = generateActions("VERIFY_EMAIL");
